import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { getApiUrl, getAuthHeaders } from '../../config/api.config';

const initialState = {
  dashboard: {
    statistics: null,
    recentSermons: [],
    recentEvents: []
  },
  loading: false,
  error: null
};

// Get dashboard statistics (Admin)
export const getDashboardStats = createAsyncThunk(
  'admin/getDashboardStats',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(getApiUrl('/admin/dashboard'), { headers: getAuthHeaders() });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch dashboard statistics');
    }
  }
);

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    clearError: (state) => { state.error = null; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardStats.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(getDashboardStats.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboard.statistics = action.payload.data.statistics;
        state.dashboard.recentSermons = action.payload.data.recentSermons;
        state.dashboard.recentEvents = action.payload.data.recentEvents;
      })
      .addCase(getDashboardStats.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
  }
});

export const { clearError } = adminSlice.actions;
export default adminSlice.reducer;
